module.exports = __webpack_public_path__ + "img/scene_halloween_backlight@2x.fbe56a69.png";